import {
  AlertDialog,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from '@@/ui/primitives/alert-dialog';
import { Button } from '@@/ui/primitives/button';
import { Spinner } from './Spinner';
import { Alert, AlertDescription, AlertTitle } from '@@/ui/primitives/alert';
import { AlertCircle } from 'lucide-react';

interface ConfirmationModalProps {
  title: string;
  description: string;
  onConfirm: () => void;
  confirmButtonText?: string;
  cancelButtonText?: string;
  destructive?: boolean;
  isLoading?: boolean;
  open?: boolean;
  onOpenChange?: (open: boolean) => void;
  errorMessage?: string;
}
export const ConfirmationModal = ({
  title,
  description,
  onConfirm,
  confirmButtonText = 'Confirm',
  cancelButtonText = 'Cancel',
  destructive = false,
  isLoading = false,
  open,
  errorMessage,
  onOpenChange
}: ConfirmationModalProps) => {
  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription>{description}</AlertDialogDescription>
        </AlertDialogHeader>
        {errorMessage && (
          <Alert variant='destructive'>
            <AlertCircle className='h-4 w-4' />
            <AlertTitle>Error</AlertTitle>
            <AlertDescription>{errorMessage}</AlertDescription>
          </Alert>
        )}
        <AlertDialogFooter className='flex gap-2'>
          <AlertDialogCancel disabled={isLoading}>{cancelButtonText}</AlertDialogCancel>
          <Button
            onClick={onConfirm}
            disabled={isLoading || !!errorMessage}
            variant={destructive ? 'destructive' : 'default'}
          >
            {isLoading ? <Spinner /> : confirmButtonText}
          </Button>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
